<div class="block" [ngClass]="field?.extraClass || ''">
  <label *ngIf="field?.label">{{field?.label}}<span class="required" *ngIf="field?.required"> *</span></label>
  <input type="text" [value]="value" [placeholder]="field?.placeholder || ''" [disabled]="disabled"
    (input)="onChange($any($event.target).value)" (blur)="onTouched()" />
  <small class="error" *ngIf="errorMessage">
    {{ errorMessage }}
  </small>
</div>